import Swal from "sweetalert2";
import { korbaProjectModels } from "../../data/korbaMapping";
import moment from "moment-hijri";
import { Col, Row } from "antd";
import { setRatingVisible } from "../../apis/slices/ratingSlice";

export const convertFileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result?.toString().split(",")[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const toFormatDate = (date: any): string => {
  if (date) return date.format("YYYY-MM-DD");
  return "";
};

export const showNotitfication = (
  text: string,
  type: "success" | "error",
  dispatch?: any,
  showClose?: boolean
): void => {
  Swal.fire({
    text: text,
    icon: type,
    showConfirmButton: dispatch? true : false,
    confirmButtonText: "تقييم الخدمة",
    timer: type === "success" && dispatch ? undefined : 3000,
    showCloseButton: dispatch? true : false, 
    customClass: {
      popup: "takaful--swal-font",
      confirmButton: "takaful--grey-button takaful--grey-button-active",

    },
  }).then((result) => {
    if (result.isConfirmed) {
      if (dispatch) {
        dispatch(setRatingVisible(true));

      }}
  });
};

export const carousselSettings = (nb: number , withDots? : boolean): any => {
  return {
    
    dots: withDots ? withDots : false,
    arrows: false,
    slidesToShow: nb,
    slidesToScroll: nb,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    rtl: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
};

export const toFormatAmount = (value: any): string => {
  const formattedValue = new Intl.NumberFormat("en-EN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return formattedValue
    .replace(/,/g, "TEMP")
    .replace(/\./g, ",")
    .replace(/TEMP/g, ".");
};

export const scroll = (currentRef: any) => {
  setTimeout(() => {
    if (currentRef.current) {
      const element = currentRef.current;
      const offset = -150;
      const top =
        element.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  }, 100);
};

export const getKey = (model: string) => {
  try {
    // eslint-disable-next-line eqeqeq
    return korbaProjectModels.filter((el: any) => el.name == model)[0].key;
  } catch (error) {
    return "";
  }
};

export const getModel = (key: any) => {
  try {
    // eslint-disable-next-line eqeqeq
    return korbaProjectModels.filter((el: any) => el.key == key)[0].name;
  } catch (error) {
    return "";
  }
};

export const toFilterData = (
  items: any,
  state: any,
  field: string = "date"
) => {
  let currentItems = items;
  if (state.year !== "") {
    if (state.month !== "") {
      const startOfMonth = moment([state.year, state.month, 1]).startOf(
        "month"
      );
      const endOfMonth = moment([state.year, state.month, 1]).endOf("month");

      currentItems = items.filter((el: any) =>
        moment(el[field]).isBetween(startOfMonth, endOfMonth)
      );
    } else {
      const startOfYear = moment("01-01-" + state.year).startOf("year");
      const endOfYear = moment("01-01-" + state.year).endOf("year");

      currentItems = items.filter((el: any) =>
        moment(el[field]).isBetween(startOfYear, endOfYear)
      );
    }
  }

  return currentItems;
};
export const getDateRange = (year: string, month: string) => {
  if (!year) return { date_from: "", date_to: "" }; // fallback if no year

  // Only year provided
  if (month === "") {
    return {
      date_from: `01-01-${year}`,
      date_to: `12-31-${year}`,
    };
  }

  const numericMonth = String(Number(month) + 1).padStart(2, "0");
  const startOfMonth = `${numericMonth}-01-${year}`;
  const endOfMonth = moment(`${year}-${numericMonth}-01`, "YYYY-MM-DD")
    .locale("en") // 👈 Force English locale for formatting
    .endOf("month")
    .format("MM-DD-YYYY");

  return {
    date_from: startOfMonth,
    date_to: endOfMonth,
  };
};
export const getCardItem = (
  name: string,
  value: string,
  suffix: string,
  img: any
) => {
  return (
    <Row
      justify="space-between"
      align="middle"
      className="takaful--service-card-bordred"
    >
      <Col xxl={2} xl={2} lg={3} md={3} sm={3} xs={3}>
        <img width={"22"} src={img} alt="" />
      </Col>
      <Col
        xxl={12}
        xl={14}
        lg={12}
        md={13}
        sm={13}
        xs={13}
        className="takaful--service-card-bordred-container"
      >
        <span className="takaful--service-card-bordred-title">{name}</span>
      </Col>
      <Col
        xxl={5}
        xl={4}
        lg={4}
        md={4}
        sm={5}
        xs={5}
        className="takaful--service-card-bordred-value"
      >
        <span>{value}</span>
      </Col>
      <Col
        xxl={2}
        xl={2}
        lg={2}
        md={2}
        sm={2}
        xs={2}
        className="takaful--service-card-bordred-value"
      >
        <p
          className={`takaful--service-card-ref ${
            suffix === "ريال" ? "icon-saudi_riyal" : ""
          }`}
        >
          {suffix === "ريال" ? "" : suffix}
        </p>
      </Col>
      <Col xxl={0} xl={0} lg={0} md={0} sm={1} xs={1} />
    </Row>
  );
};
